module.exports = __webpack_public_path__ + "media/images/webpage/hotels/1321/floorguide/course-1-photo-4-d33e3a0aedd6e2378c69e40599a5e504.webp";